<template>
  <div>
    <ModalPayInvoice
      :loading="isLoading"
      :invoice="invoice"
      :balance="balance"
      @onTopup="beginTopup = true"
      @onPay="handlePay"
    />
    <ModalCreatePin
      redirect="?redirect=invoice-komtim"
    />
    <ModalPIN
      id="modal-verify-pin"
      :partner-id="profile.partner_id"
      no-close-on-backdrop
      no-close-on-esc
      title="Masukkan PIN"
      description="Masukkan 6 digit PIN untuk melanjutkan pembayaran"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="payInvoice"
      @on-cancel-button="$bvModal.show('pay-invoice')"
    />
    <ModalConfirm
      id="success-pay-invoice"
      title="Pembayaran Berhasil"
      description=""
    />
    <TopupFlow
      :loading.sync="isLoading"
      :begin-topup.sync="beginTopup"
      :data-bill-exist.sync="dataBillExist"
      @showTopupModal="$bvModal.hide('pay-invoice')"
      @closeTopupModal="$bvModal.show('pay-invoice')"
    />
    <EvaluationFlow
      :invoice-id="invoice.id || +$route.params.id"
      @confirm="$bvModal.show('pay-invoice')"
    />
  </div>
</template>

<script>
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import { mapState } from 'vuex'
import { komshipAxiosIns, komtimAxiosIns } from '@/libs/axios'
import ModalCreatePin from '../../komcard/components/ModalCreatePin.vue'
import ModalPayInvoice from '../modal/ModalPayInvoice.vue'
import ModalConfirm from '../modal/ModalConfirm.vue'
import TopupFlow from '../modal/TopupFlow.vue'
import EvaluationFlow from '../modal/EvaluationFlow.vue'

export default {
  components: {
    ModalPayInvoice, ModalCreatePin, ModalPIN, ModalConfirm, TopupFlow, EvaluationFlow,
  },
  props: {
    invoice: {
      type: Object,
      default: () => ({
        id: null,
        invoice_code: '',
        total_admin_fee: 0,
        total_salary_talent: 0,
        total_tax: 0,
        total_additional_cost: 0,
        ppn_numerator: 0,
        admin_service: 0,
        total_nominal: 0,
      }),
    },
    balance: {
      type: Object,
      default: () => ({
        ideal_balance: 0,
        ongkir_retur_potential: 0,
        income_order_potential: 0,
        ongkir_retur_on_finished: 0,
        ongkir_risk_become_retur: 0,
        on_withdrawl: 0,
      }),
    },
  },
  data() {
    return {
      dataBillExist: null,
      beginTopup: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('dashboard', ['profile']),
  },
  methods: {
    async handlePay() {
      try {
        const { data: { data: { is_set } } } = await komshipAxiosIns.get('/v1/pin/check')
        this.$bvModal.hide('pay-invoice')
        if (!is_set) {
          this.$bvModal.show('modal-check-pin')
          return
        }
        this.$bvModal.show('modal-verify-pin')
      } catch (error) {
        this.$toast_error({ message: 'Gagal check pin, silahkan coba lagi' })
      }
    },
    async payInvoice() {
      try {
        await komtimAxiosIns.post('/v1/partner/invoices/pay', {
          invoice_code: this.invoice.invoice_code,
          partner_id: this.profile.partner_id,
        })
        this.$emit('onPayInvoice')
        this.$bvModal.show('success-pay-invoice')
      } catch (error) {
        this.$toast_error({ message: 'Gagal melakukan pembayaran invoice' })
      }
    },
  },
}
</script>
